import { render, staticRenderFns } from "./couponRefundNoticeModal.vue?vue&type=template&id=310a8176&scoped=true"
import script from "./couponRefundNoticeModal.vue?vue&type=script&lang=ts"
export * from "./couponRefundNoticeModal.vue?vue&type=script&lang=ts"
import style0 from "./couponRefundNoticeModal.vue?vue&type=style&index=0&id=310a8176&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a8176",
  null
  
)

export default component.exports